// const API_BASE = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001/api`;
const API_BASE = 'https://be-schoolapp.vistaraklyqstech.com/api';

export default API_BASE;
